import React, { Component } from 'react';
import Loading from '../Loading.js'
import NamezzzSector from '../../Fields/NamezzzSector.js'
import { getSectors, postSector, postCompleteRegistrant } from '../../Api/UserActions.js'
import { getTranslation } from '../../Utilities/GetTranslation.js'

declare var globalSns;

class Branches extends Component {
    constructor(props) {
        super(props);

        this.state = {}

        this.onChange = this.onChange.bind(this);
        this.updateSector = this.updateSector.bind(this);
    }

    componentWillMount() {
        this.loadData();
    }

    loadData() {
        if (this.props.job.hasSectorQuestion) {            
            getSectors(globalSns.languageId,
                (data) => {
                    var record1Id = null;
                    var record2Id = null;
                    var record3Id = null;
                    var sector1 = "";
                    var sector2 = "";
                    var sector3 = "";
                    var sector1Id = null;
                    var sector2Id = null;
                    var sector3Id = null;
                    var sector1SynonymId = null;
                    var sector2SynonymId = null;
                    var sector3SynonymId = null;
                    
                    if (data.length > 0) {
                        record1Id = data[0].id;
                        sector1 = data[0].sectorText;
                        sector1Id = data[0].sectorId;
                        sector1SynonymId = data[0].synonymId;
                    }
                    if (data.length > 1) {
                        record2Id = data[1].id;
                        sector2 = data[1].sectorText;
                        sector2Id = data[1].sectorId;
                        sector2SynonymId = data[1].synonymId;
                    }
                    if (data.length > 2) {
                        record3Id = data[2].id;
                        sector3 = data[2].sectorText;
                        sector3Id = data[2].sectorId;
                        sector3SynonymId = data[2].synonymId;
                    }
    
                    this.setState({
                        showSectorQuestion: true,
                        record1Id: record1Id,
                        record2Id: record2Id,
                        record3Id: record3Id,
                        sector1: sector1,
                        sector2: sector2,
                        sector3: sector3,
                        sector1Id: sector1Id,
                        sector2Id: sector2Id,
                        sector3Id: sector3Id,
                        sector1SynonymId: sector1SynonymId,
                        sector2SynonymId: sector2SynonymId,
                        sector3SynonymId: sector3SynonymId
                    });
                });
        } else {
            this.setState({
                showSectorQuestion: false
            });
        }
    }

    onChange(e, id, synonymId) {
        this.setState({
            [e.target.id] : e.target.value,
            [e.target.id + "Id"] : id,
            [e.target.id + "SynonymId"] : synonymId,
        }); 
    }

    updateSector(e) {
        var source = e.target.id.substring(e.target.id.length -1);

        var keyRec = this.state["record" + source + "Id"];
        var keySectorId = this.state["sector" + source + "Id"];
        var keySynonymId = this.state["sector" + source + "SynonymId"];
        var keySector = this.state["sector" + source];

        postSector(keyRec, keySectorId, keySynonymId, keySector, (data) => {
            this.setState({
                [keyRec]: (data == null) ? null : data.id
            });

            postCompleteRegistrant(globalSns.jobId, globalSns.languageId, () => {});
        });
    }

    render() {
        
        if (!this.state.showSectorQuestion) {
            return "";
        }

        if (this.state.sector1 == null) {
            return (
                <Loading/>
            );
        }

        return (
            <div className="tr full-width">
                <div className="FieldLabel td">
                    <label>{getTranslation("sns.webparts.questions.branches")}</label>
                </div>
                <div className="EditingFormValueCell td">
                    <NamezzzSector id="sector1" seqlang={globalSns.languageId} value={this.state.sector1} onChange={this.onChange} onBlur={this.updateSector} className="full" /><br/>
                    <NamezzzSector id="sector2" seqlang={globalSns.languageId} value={this.state.sector2} onChange={this.onChange} onBlur={this.updateSector} className="full" /><br/>
                    <NamezzzSector id="sector3" seqlang={globalSns.languageId} value={this.state.sector3} onChange={this.onChange} onBlur={this.updateSector} className="full" />
                </div>
            </div>
        );
    }
}

export default Branches;


// WEBPACK FOOTER //
// ./src/Components/Tabs/Branches.js